import { useEffect } from 'react'

const appScheme = 'reggora://'
const MobileRouting = ({ location }) => {
  useEffect(() => {
    // location.search will pass down any query params to mobile. Re-encoding
    // through URLSearchParams (rather than forwarding the raw string) strips
    // any unescaped characters a hand-crafted link could smuggle through.
    const query = new URLSearchParams(location.search).toString()
    // eslint-disable-next-line no-restricted-syntax -- fixed reggora:// scheme; the query is re-encoded through URLSearchParams above
    window.location.href = query ? `${appScheme}?${query}` : appScheme
  }, [])

  return null
}

export default MobileRouting
